import { render, staticRenderFns } from "./POrdersWidget.vue?vue&type=template&id=55717891&scoped=true"
import script from "./POrdersWidget.vue?vue&type=script&lang=js"
export * from "./POrdersWidget.vue?vue&type=script&lang=js"
import style0 from "./POrdersWidget.vue?vue&type=style&index=0&id=55717891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55717891",
  null
  
)

export default component.exports